import _ from 'lodash';
import React, { Fragment } from 'react';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import IconButton from 'material-ui/IconButton';
import TextField from 'material-ui/TextField';
import ContentAddIcon from 'material-ui/svg-icons/content/add-circle-outline';
import ContentRemoveIcon from 'material-ui/svg-icons/content/remove-circle-outline';
import InfoIcon from 'material-ui/svg-icons/action/info';

import { ventilationNames, imoClassNames, imoAppNames, iceClassNames, fitted, IGS_TYPES } from 'constants/vesselRequirements';
import NumberField from '../../../Base/NumberField';

const styles = {
    selectorFitted: {
        fontSize: '13px',
    },
    infoIcon: {
        width: '1em',
        height: '1em',
        verticalAlign: 'middle',
        margin: '-3px 0 0 0.5em',
        color: '#dadada',
        cursor: 'pointer',
    },
};

class TechEquipCertificate extends React.Component {
    changeFields = (fieldName, value) => {
        const { changeField } = this.props;
        const toChange = [{
            field: `techEquipCertificate.${fieldName}`,
            value,
        }];

        switch (true) {
        case (fieldName === fitted.ventilationFitted && !value):
            toChange.push({
                field: `techEquipCertificate.${fitted.ventilation}`,
                value: '',
            });
            break;

        case (fieldName === fitted.imoFitted && !value):
            toChange.push(
                {
                    field: 'techEquipCertificate.imoApp',
                    value: '',
                },
                {
                    field: 'techEquipCertificate.imoClass',
                    value: '',
                },
            );
            break;

        case (fieldName === fitted.referPlugFitted && !value):
            toChange.push({
                field: 'techEquipCertificate.referPlugsAmount',
                value: 0,
            });
            break;
    
        default:
            break;
        }

        changeField(toChange);
    }

    render() {
        const {
            confirmed, changeField, getError, modifiedFields, underStyle, toggleLabelStyle, 
        } = this.props;
        const { changeFields } = this;
        const {
            co2Fitted,
            a60BulkheadFitted,
            newPanama,
            cementHolesFitted,
            cementHolesCount,
            cementHolesDia,
            referPlugFitted,
            itfFitted,
            lakesFitted,
            strengthenHeavy,
            logsFitted,
            aussieFitted,
            iceClass,
            ventilation,
            ventilationFitted,
            imoApp,
            imoClass,
            imoFitted,
            bwts,
            coiled,
            containerFitted,
            carFitted,
            rampway,
            lxb,
            grainFitted,
            grainHoles,
            grainDia,
            cargoTankDryer,
            cargoCoolingSystem,
            crudeOilWashing,
            rcttms,
            rctpms,
            bowChainStopper,
            chainSize,
            ngs,
            ngsCapacity,
            vrs,
            vrsNumLines,
            bowThruster,
            bowThrusterNum,
            bowThrusterBhp,
            bowThrusterKw,
            stemThruster,
            stemThrusterNum,
            stemThrusterBhp,
            stemThrusterKw,
            scrubberFitted,
            referPlugsAmount,
            igs,
        } = this.props.techEquipCertificate;

        const igsSystems = (igs && igs.systems) || [];
        if (!igsSystems.length) {
            igsSystems.push({
                type: '',
                capacity: '',
                percentage: '',
            });
        }

        function renderSelectFitted(fieldName, fieldValue, label, hint = '') {
            if (hint) {
                label = (
                    <React.Fragment>
                        {label}
                        <span data-tip={hint} style={{ pointerEvents: 'all' }}>
                            <InfoIcon style={styles.infoIcon} />
                        </span>
                    </React.Fragment>
                );
            }
            return (
                <SelectField
                    value={fieldValue}
                    onChange={(e, i, value) => changeFields(fieldName, value)}
                    disabled={confirmed}
                    name={fieldName}
                    floatingLabelText={label}
                    floatingLabelStyle={{ fontSize: '13px' }}
                    labelStyle={modifiedFields && modifiedFields.includes(`techEquipCertificate.${fieldName}`) ? toggleLabelStyle : null}
                    underlineStyle={modifiedFields && modifiedFields.includes(`techEquipCertificate.${fieldName}`) ? underStyle : null}
                    autoWidth
                    fullWidth
                >
                    <MenuItem value={null} primaryText={undefined} />
                    <MenuItem value primaryText='Yes' />
                    <MenuItem value={false} primaryText='No' />
                </SelectField>
            );
        }

        function renderNumberField(field, value, label, disabled = false, floatingNumber = false) {
            return (
                <NumberField
                    name={`techEquipCertificate.${field}`}
                    floatingLabelText={label}
                    floatingLabelStyle={{ fontSize: '13px' }}
                    value={value || ''}
                    style={styles.selectorFitted}
                    fullWidth
                    floatNumber={floatingNumber}
                    disabled={disabled}
                    errorText={getError(`techEquipCertificate.${field}`)}
                    onChange={(e, value) => {
                        changeField([{
                            field: `techEquipCertificate.${field}`,
                            value,
                            type: 'number',
                        }]);
                    }}
    
                    underlineStyle={modifiedFields && modifiedFields.includes(`techEquipCertificate.${field}`) ? underStyle : null}
                />
            );
        }

        function renderTextField(field, value, label, disabled = false) {
            return (
                <TextField
                    name={`techEquipCertificate.${field}`}
                    floatingLabelText={label}
                    floatingLabelStyle={{ fontSize: '13px' }}
                    value={value || ''}
                    style={styles.selectorFitted}
                    fullWidth
                    disabled={disabled}
                    errorText={getError(`techEquipCertificate.${field}`)}
                    onChange={(e, value) => {
                        changeField([{
                            field: `techEquipCertificate.${field}`,
                            value,
                            type: 'number',
                        }]);
                    }}
    
                    underlineStyle={modifiedFields && modifiedFields.includes(`techEquipCertificate.${field}`) ? underStyle : null}
                />
            );
        }

        return (
            <Fragment>
                <div className='row'>
                    <div className='col-xs-12' style={{ margin: '0px 0px 20px 0px' }}>
                        <span className='name-block static huge-name'>TECHNICAL EQUIPMENT / CERTIFICATE</span>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-xs-3'>
                        { renderSelectFitted(fitted.co2Fitted, co2Fitted, 'CO2Fitted') }
                    </div>
                    <div className='col-xs-3'>
                        { renderSelectFitted(fitted.a60BulkheadFitted, a60BulkheadFitted, 'A60 bulkhead fitted') }
                    </div>
                    <div className='col-xs-3'>
                        { renderSelectFitted(fitted.newPanama, newPanama, 'New Panama') }
                    </div>
                    <div className='col-xs-3'>
                        { renderSelectFitted(fitted.itfFitted, itfFitted, 'Itf fitted') }
                    </div>
                    <div className='col-xs-3'>
                        { renderSelectFitted(fitted.lakesFitted, lakesFitted, 'Lakes fitted') }
                    </div>
                    <div className='col-xs-3'>
                        { renderSelectFitted(fitted.logsFitted, logsFitted, 'Logs fitted') }
                    </div>
                    <div className='col-xs-3'>
                        { renderSelectFitted(fitted.strengthenHeavy, strengthenHeavy, 'Strengthened heavy') }
                    </div>
                    <div className='col-xs-3'>
                        { renderSelectFitted(fitted.aussieFitted, aussieFitted, 'Aussie fitted') }
                    </div>
                    <div className='col-xs-3'>
                        { renderSelectFitted(fitted.scrubberFitted, scrubberFitted, 'Scrubber fitted') }
                    </div>
                    <div className='col-xs-3'>
                        { renderSelectFitted(fitted.ventilationFitted, ventilationFitted, 'Ventilation fitted') }
                    </div>
                    <div className='col-xs-3'>
                        <SelectField
                            value={ventilation}
                            onChange={(e, i, value) => {
                                changeField([{
                                    field: 'techEquipCertificate.ventilation',
                                    value,
                                }]);
                            }}
                            style={styles.selectorFitted}
                            disabled={!ventilationFitted}
                            errorText={getError('techEquipCertificate.ventilation')}
                            maxHeight={200}
                            name='ventilation'
                            floatingLabelText='Ventilation'
                            fullWidth
                            autoWidth
                            underlineStyle={modifiedFields && modifiedFields.includes('techEquipCertificate.ventilation') ? underStyle : null}
                        >
                            {
                                ventilationNames.map((ventilationName, index) => (
                                    <MenuItem
                                        key={`${ventilationName}_${index}`}
                                        value={ventilationName}
                                        primaryText={ventilationName}
                                    />
                                ))
                            }
                        </SelectField>
                    </div>
                    <div className='col-xs-3'>
                        <SelectField
                            value={iceClass}
                            onChange={(e, i, value) => {
                                changeField([{
                                    field: 'techEquipCertificate.iceClass',
                                    value,
                                }]);
                            }}
                            style={styles.selectorFitted}
                            disabled={confirmed}
                            errorText={getError('techEquipCertificate.iceClass')}
                            maxHeight={200}
                            name='iceClass'
                            floatingLabelText='Ice Class'
                            fullWidth
                            autoWidth
                            underlineStyle={modifiedFields && modifiedFields.includes('techEquipCertificate.iceClass') ? underStyle : null}
                        >
                            {
                                iceClassNames.map((iceClassName, index) => (
                                    <MenuItem
                                        key={`${iceClassName}_${index}`}
                                        value={iceClassName || ''}
                                        primaryText={iceClassName}
                                    />
                                ))
                            }
                        </SelectField>
                    </div>
                    <div className='col-xs-3'>
                        { renderSelectFitted(fitted.imoFitted, imoFitted, 'Imo fitted') }
                    </div>
                    <div className='col-xs-3'>
                        <SelectField
                            value={imoClass}
                            onChange={(e, i, value) => {
                                changeField([{
                                    field: 'techEquipCertificate.imoClass',
                                    value,
                                }]);
                            }}
                            style={styles.selectorFitted}
                            disabled={!imoFitted}
                            errorText={getError('techEquipCertificate.imoClass')}
                            maxHeight={200}
                            name='imoClass'
                            floatingLabelText='Imo class'
                            fullWidth
                            autoWidth
                            underlineStyle={modifiedFields && modifiedFields.includes('techEquipCertificate.imoClass') ? underStyle : null}
                        >
                            {
                                imoClassNames.map((imoClassName, index) => (
                                    <MenuItem
                                        key={`${imoClassName}_${index}`}
                                        value={imoClassName}
                                        primaryText={imoClassName}
                                    />
                                ))
                            }
                        </SelectField>
                    </div>
                    <div className='col-xs-3'>
                        <SelectField
                            value={imoApp}
                            onChange={(e, i, value) => {
                                changeField([{
                                    field: 'techEquipCertificate.imoApp',
                                    value,
                                }]);
                            }}
                            style={styles.selectorFitted}
                            errorText={getError('techEquipCertificate.imoApp')}
                            maxHeight={200}
                            name='imoApp'
                            floatingLabelText='Appendix'
                            fullWidth
                            autoWidth
                            underlineStyle={modifiedFields && modifiedFields.includes('techEquipCertificate.imoApp') ? underStyle : null}
                        >
                            {
                                imoAppNames.map((imoAppName, index) => (
                                    <MenuItem
                                        key={`${imoAppName}_${index}`}
                                        value={imoAppName}
                                        primaryText={imoAppName}
                                    />
                                ))
                            }
                        </SelectField>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-xs-3'>
                        { renderSelectFitted(fitted.referPlugFitted, referPlugFitted, 'Refer plug fitted') }
                    </div>
                    <div className="col-xs-3">
                        <NumberField
                            name='techEquipCertificate.referPlugsAmount'
                            floatingLabelText='Reefer plugs amount'
                            value={referPlugsAmount || ''}
                            style={styles.selectorFitted}
                            fullWidth
                            disabled={!referPlugFitted}
                            errorText={getError('techEquipCertificate.referPlugsAmount')}
                            onChange={(e, value) => {
                                changeField([{
                                    field: 'techEquipCertificate.referPlugsAmount',
                                    value,
                                    type: 'number',
                                }]);
                            }}

                            underlineStyle={modifiedFields && modifiedFields.includes('techEquipCertificate.referPlugsAmount') ? underStyle : null}
                        />
                    </div>
                    <div className='col-xs-3'>
                        { renderSelectFitted(fitted.bwts, bwts, 'BWTS', 'Ballast water treatment system') }
                    </div>
                    <div className='col-xs-3'>
                        { renderSelectFitted(fitted.coiled, coiled, 'Coiled') }
                    </div>
                    <div className='col-xs-3'>
                        { renderSelectFitted(fitted.containerFitted, containerFitted, 'Container fitted') }
                    </div>
                    <div className='col-xs-3'>
                        { renderSelectFitted(fitted.carFitted, carFitted, 'Car fitted') }
                    </div>
                    <div className='col-xs-3'>
                        { renderSelectFitted(fitted.rampway, rampway, 'Rampway') }
                    </div>
                    <div className='col-xs-3'>
                        { renderTextField('lxb', lxb, 'lxb, m', !rampway) }
                    </div>
                </div>
                <div className='row'>
                    <div className='col-xs-3'>
                        { renderSelectFitted(fitted.grainFitted, grainFitted, 'Grain fitted') }
                    </div>
                    <div className='col-xs-3'>
                        { renderNumberField('grainHoles', grainHoles, 'Num of holes', !grainFitted) }
                    </div>
                    <div className='col-xs-3'>
                        { renderNumberField('grainDia', grainDia, 'Dia, mm', !grainFitted, true) }
                    </div>
                </div>
                <div className='row'>
                    <div className='col-xs-3'>
                        { renderSelectFitted(fitted.cementHolesFitted, cementHolesFitted, 'Cement holes fitted') }
                    </div>
                    <div className='col-xs-3'>
                        { renderNumberField('cementHolesCount', cementHolesCount, 'Num of holes', !cementHolesFitted) }
                    </div>
                    <div className='col-xs-3'>
                        { renderNumberField('cementHolesDia', cementHolesDia, 'Dia, mm', !cementHolesFitted, true) }
                    </div>
                </div>
                <div className='row'>
                    <div className='col-xs-3'>
                        { renderSelectFitted(fitted.cargoTankDryer, cargoTankDryer, 'Cargo tank dryer') }
                    </div>
                    <div className='col-xs-3'>
                        { renderSelectFitted(fitted.cargoCoolingSystem, cargoCoolingSystem, 'Cargo cooling system') }
                    </div>
                    <div className='col-xs-3'>
                        { renderSelectFitted(fitted.crudeOilWashing, crudeOilWashing, 'Crude oil washing') }
                    </div>
                    <div className='col-xs-3'>
                        { renderSelectFitted(fitted.rcttms, rcttms, 'RCTTMS', 'Remote cargo tank temperature monitoring system') }
                    </div>
                    <div className='col-xs-3'>
                        { renderSelectFitted(fitted.rctpms, rctpms, 'RCTPMS', 'Remote cargo tank pressure monitoring system') }
                    </div>
                    <div className='col-xs-3'>
                        { renderSelectFitted(fitted.bowChainStopper, bowChainStopper, 'Bow chain stopper') }
                    </div>
                    <div className='col-xs-3'>
                        { renderNumberField('chainSize', chainSize, 'Chain size, mm', !bowChainStopper, true) }
                    </div>
                </div>
                <div className='row'>
                    <div className='col-xs-3'>
                        { renderSelectFitted(fitted.ngs, ngs, 'NGS') }
                    </div>
                    <div className='col-xs-3'>
                        { renderNumberField('ngsCapacity', ngsCapacity, 'Capacity, cbm/hr (95%)', !ngs, true) }
                    </div>
                    <div className='col-xs-3'>
                        { renderSelectFitted(fitted.vrs, vrs, 'VRS') }
                    </div>
                    <div className='col-xs-3'>
                        { renderNumberField('vrsNumLines', vrsNumLines, 'Num of independent lines', !vrs) }
                    </div>
                    <div className='col-xs-3'>
                        { renderSelectFitted(fitted.bowThruster, bowThruster, 'Bow thruster') }
                    </div>
                    <div className='col-xs-3'>
                        { renderNumberField('bowThrusterNum', bowThrusterNum, 'Num, pc', !bowThruster) }
                    </div>
                    <div className='col-xs-3'>
                        { renderNumberField('bowThrusterBhp', bowThrusterBhp, 'BHP', !bowThruster, true) }
                    </div>
                    <div className='col-xs-3'>
                        { renderNumberField('bowThrusterKw', bowThrusterKw, 'kW', !bowThruster, true) }
                    </div>
                    <div className='col-xs-3'>
                        { renderSelectFitted(fitted.stemThruster, stemThruster, 'Stem thruster') }
                    </div>
                    <div className='col-xs-3'>
                        { renderNumberField('stemThrusterNum', stemThrusterNum, 'Num, pc', !stemThruster) }
                    </div>
                    <div className='col-xs-3'>
                        { renderNumberField('stemThrusterBhp', stemThrusterBhp, 'BHP', !stemThruster, true) }
                    </div>
                    <div className='col-xs-3'>
                        { renderNumberField('stemThrusterKw', stemThrusterKw, 'kW', !stemThruster, true) }
                    </div>
                </div>
                {igsSystems.map((system, index) => (
                    <div className='row' key={`isgSystems_${index}`}>
                        <div className='col-xs-3'>
                            {index === 0 && (
                                renderSelectFitted(fitted.igsFitted, igs && igs.fitted, 'IGS')
                            )}
                        </div>
                        <div className='col-xs-3'>
                            <SelectField
                                value={system.type || ''}
                                onChange={(e, i, value) => {
                                    changeField([{
                                        field: `techEquipCertificate.igs.systems[${index}].type`,
                                        value,
                                    }]);
                                }}
                                disabled={!(igs && igs.fitted)}
                                errorText={getError && getError(`igs.systems[${index}].type`)}
                                maxHeight={200}
                                name='type'
                                floatingLabelText="IGS type"
                                floatingLabelStyle={{ fontSize: '13px' }}
                                fullWidth
                                autoWidth
                                underlineStyle={modifiedFields && modifiedFields.includes(`igs.systems[${index}].type`) ? underStyle : null}
                            >
                                {
                                    ['', ...IGS_TYPES].map(type => (<MenuItem
                                        key={type}
                                        value={type}
                                        primaryText={type}
                                    />))
                                }
                            </SelectField>
                        </div>
                        <div className='col-xs-3'>
                            { renderNumberField(`igs.systems[${index}].capacity`, system.capacity, 'Capacity, cbm/hr', !(igs && igs.fitted), true) }
                        </div>
                        <div className='col-xs-2'>
                            { renderNumberField(`igs.systems[${index}].percentage`, system.percentage, '%', !(igs && igs.fitted), true) }
                        </div>
                        <div className='col-xs-1'>
                            <div style={{ margin: '25px 0 0 0' }}>
                                {index === 0 && (
                                    <IconButton
                                        disabled={!(igs && igs.fitted)}
                                        onClick={this.addIgsRow}
                                    >
                                        <ContentAddIcon color='green' />
                                    </IconButton>
                                )}
                                {index !== 0 && (
                                    <IconButton
                                        disabled={!(igs && igs.fitted)}
                                        onClick={() => {
                                            this.removeIgsRow(index);
                                        }}
                                    >
                                        <ContentRemoveIcon color='red' />
                                    </IconButton>
                                )}
                            </div>
                        </div>
                    </div>
                ))}
            </Fragment>
        );
    }

    addIgsRow = () => {
        const igs = _.cloneDeep(this.props.techEquipCertificate.igs);
        igs.systems.push({
            type: '',
            capacity: '',
            percentage: '',
        });
        this.props.changeField({ field: 'techEquipCertificate.igs', value: igs });
    };

    removeIgsRow = (index) => {
        const igs = _.cloneDeep(this.props.techEquipCertificate.igs);
        igs.systems.splice(index, 1);
        this.props.changeField({ field: 'techEquipCertificate.igs', value: igs });
    };
}

export default TechEquipCertificate;



// WEBPACK FOOTER //
// ./app/components/Vessels/Single/Rows/TechEquipCertificate.jsx